import i18n, { resources, defaultLanguage } from '../i18n'

export const getLanguage = (): keyof typeof resources => {
  const currentLanguage = i18n.language as keyof typeof resources
  const resource = resources[currentLanguage]

  return resource ? currentLanguage : defaultLanguage
}
